import axios from 'axios';

const AjaxRequester = {
  HEADER: {
    'Content-Type': 'application/vnd.api+json'
  },

  async getJsonApi(path) {
    try {
      const response = await axios.get(path, { headers: this.HEADER });
      return response.data.data;
    } catch (error) {
      console.error('Error in getJsonApi:', error);
      throw error;
    }
  },

  async getFromView(path, queryParams = []) {
    queryParams.push({ name: '_format', value: 'json' });
    return this._get(path, queryParams);
  },

  async getFromSolr(queryParams = []) {
    return this._get('/api/internal', queryParams);
  },

  async _get(path, queryParams = []) {
    const queryParam = queryParams.map(param => `${param.name}=${param.value}`).join('&');
    const url = `${path}${queryParam.length > 0 ? '?' + queryParam + '&collation=fr' : ''}`;

    try {
      const response = await axios.get(url, {
        withCredentials: true,
        headers: this.HEADER,
      });
      return response.data;
    } catch (error) {
      console.error('Error in _get:', error);
      throw error;
    }
  },
  getTaxonomyTermSolrParams: function (vid, tidParent, rows = 1000) {
    let vidFilter = Array.isArray(vid) ? '(' + vid.map(v => 'ss_vid:' + v).join(' OR ') + ')' : 'ss_vid:' + vid;

    let params = [{
      name: 'q',
      value: 'index_id:taxonomy_term'
    },
      {
        name: 'fq',
        value: vidFilter
      }, {
        name: 'rows',
        value: rows
      }, {
        name: 'fl',
        value: 'ss_vid,its_tid,ss_name,ss_field_slug'
      },
      {
        name: 'group',
        value: true
      },
      {
        name: 'group.field',
        value: 'ss_vid'
      },
      {
        name: 'group.limit',
        value: rows
      }
    ];

    return params;
  },

  convertSolrTermToJsonApi: function (solrTerms) {
    let terms = [];
    for (let term of solrTerms) {
      terms.push({
        type: 'taxonomy_term--' + term.ss_vid,
        attributes: {
          drupal_internal__tid: term.its_tid,
          name: term.ss_name,
          slug: term.ss_field_slug?term.ss_field_slug:''
        }
      });
    }
    return terms;
  },

  // Format solr data to render in view - Item.jsx
  convertSolrFormationToViewExport: function (solrProducts) {
    let products = [];

    for (let item of solrProducts) {
      let product = item.doclist?.docs[0] || item;

      products.push({
        title: product.ss_title_1,
        summary: product.ss_summary,
        summary_2: product.ss_field_summary,
        field_product_duration: product.ss_field_formation_duration,
        field_formation_schedule: product.sm_field_formation_schedule_global && product.sm_field_formation_schedule_global.length > 0 ? product.sm_field_formation_schedule_global[0] : undefined,
        field_price_list: product.ss_field_price_list,
        field_formation_shortage: product.bs_field_formation_shortage,
        field_formation_type: product.sm_field_formation_type && product.sm_field_formation_type.length > 0 ? product.sm_field_formation_type[0] : undefined,
        field_formation_age: product.itm_field_formation_age,
        view_commerce_product: product.ss_url
          ? product.ss_url
          : '/product/' + product.its_product_id,
        product_id: product.its_product_id,
        field_training_center_id: product.sm_field_training_center,
        field_training_center: product.sm_field_training_center_1,
        field_start_date: product.dm_field_start_date,
        field_sessions: product.sm_variation_sessions,
        field_store_color: product.sm_field_store_color,
        field_variation_status: product.bs_variations_status,
        type: product.ss_type,
      });
    }

    return products;
  }

};

export default AjaxRequester;
